import { getHotelAppropriateDestination } from "src/utils/hooks/useHotelDestinationFromUrl";
import type { HotelProviderKind } from "../../../utils/types/accommodationProviders";
import type { SearchResponse } from "../../../api/SearchResponse";
import { type GeoKind, isPointKind } from "../../../utils/geoKind";
import type { ScheduledTimelineCell } from "../ScheduleTimeline/cell/ScheduledCell";
import type { Cell } from "../UnscheduledTimeline/cell/Cell";

export type AccommodationPromoTimelineProps =
  | { response?: never }
  | {
      response: SearchResponse;
      routeIndex: number;
      destination?: {
        canonicalName: string;
        shortName: string;
        kind?: GeoKind;
      };
    };

export function createScheduledAccommodationPromoCells(
  cells: ScheduledTimelineCell[],
  props: AccommodationPromoTimelineProps,
) {
  const cell = createAccommodationCellFromProps(props);
  if (cell) cells.push(cell);
}

export function createUnScheduledAccommodationPromoCells(
  cells: Cell[],
  props: AccommodationPromoTimelineProps,
) {
  const cell = createAccommodationCellFromProps(props);
  if (cell) cells.push(cell);
}

export function createAccommodationCellFromProps(
  props: AccommodationPromoTimelineProps,
): AccommodationPromoCell | undefined {
  if (props.response && props.destination) {
    return createAccommodationCellFromPlace(
      {
        canonicalName: props.destination.canonicalName,
        ...getHotelAppropriateDestination(
          props.response,
          props.destination,
          props.routeIndex,
        ),
      },
      props.response.routes[props.routeIndex].hotelInfo.providerKind,
    );
  }
}

export function createAccommodationCellFromPlace(
  place: { canonicalName: string; shortName: string; kind?: GeoKind },
  hotelProvider: HotelProviderKind,
): AccommodationPromoCell {
  return {
    type: "accommodation",
    id: `accommodation-${place.canonicalName}`,
    placeName: place.shortName,
    provider: hotelProvider,
    useNearbyCopy: !place.kind || isPointKind(place.kind), // Uses 'near' instead of 'in'
  };
}

export type AccommodationPromoCell = {
  type: "accommodation";
  id: string;
  placeName: string;
  provider: HotelProviderKind;
  useNearbyCopy: boolean;
};
